module.exports = __webpack_public_path__ + "static/media/angry.d0f14127.png";